import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import CSSModules from 'react-css-modules';

import styles from './styles.styl';
import Avatar from '../../../Avatar';

const CommunityCardImpl = ({
  avatar: { name, src, size = 100 },
  renderSubTitle,
  renderSubContent,
  renderContent,
  renderActions,
  renderTitle,
  renderInfo,
}) => {
  return (
    <div styleName="Card">
      <div styleName="CardWrapper">
        <div styleName="CardContent">
          <div styleName="CardLogo">
            <Avatar
              children={name}
              src={src}
              size={size}
              bordered
              position="center"
            />
          </div>
          <div styleName="CardBody">
            <div styleName="CardTitle">{renderTitle()}</div>
            {renderSubTitle && (
              <div styleName="CardSubTitle">{renderSubTitle()}</div>
            )}
            <div styleName="CardText">{renderContent()}</div>
            {renderSubContent && (
              <div styleName="CardSubContent">{renderSubContent()}</div>
            )}
            <div styleName="CardInfo">{renderInfo()}</div>
          </div>
        </div>
        <div styleName="CardActions">{renderActions()}</div>
      </div>
    </div>
  );
};

export const CommunityCard = compose(
  CSSModules(styles, { allowMultiple: true }),
)(CommunityCardImpl);

const propTypes = {
  renderSubTitle: PropTypes.func,
  renderSubContent: PropTypes.func,
  renderContent: PropTypes.func,
  renderActions: PropTypes.func,
  renderTitle: PropTypes.func,
  renderInfo: PropTypes.func,
  avatar: PropTypes.shape({
    name: PropTypes.string.isRequired,
    src: PropTypes.string,
    size: PropTypes.number,
  }).isRequired,
};
const defaultProps = {
  renderSubTitle: null,
  renderSubContent: null,
  renderContent: () => {},
  renderActions: () => {},
  renderTitle: () => {},
  renderInfo: () => {},
};

CommunityCardImpl.propTypes = propTypes;
CommunityCardImpl.defaultProps = defaultProps;
CommunityCard.propTypes = propTypes;
CommunityCard.defaultProps = defaultProps;



// WEBPACK FOOTER //
// ./src/components/Communities/Components/CommunityCard/index.jsx